import React, { useCallback, useEffect, useState } from 'react';

import { getAppLogo } from 'services/requests';

import Loader from 'components/Loader/Loader';
import AppProviders from 'providers';

import './App.css';
import LoginButtons from 'components/LoginButtons';
import RedirectSignIn from 'components/RedirectSignIn';
import { isRedirectSignIn } from 'signIn/redirectSignIn';

/** Popup/new-tab sign-in that hands the token back over Pusher (ConnectWise POD, portal inside Teams). */
const PusherSignIn: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [appLogo, setAppLogo] = useState<string>('');
  const [showButtons, setShowButtons] = useState<boolean>(true);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const onMount = useCallback(async () => {
    setLoading(true);
    await getAppLogo()
      .then(res => {
        setAppLogo(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    onMount();
  }, []);

  if (loading) return <Loader />;
  return (
    <AppProviders>
      <div className="auth-page">
        <div className="dialog-container">
          <div className="container-logo">
            <img src={appLogo} alt="logo" className="logo" />
          </div>

          {showButtons && (
            <LoginButtons
              onSuccess={() => {
                setShowButtons(false);
                setShowSuccess(true);
              }}
            />
          )}

          {showSuccess && (
            <div className="success">
              <div>We sent your sign-in back to the app.</div>
              <div>You can close this tab now.</div>
            </div>
          )}
        </div>
      </div>
    </AppProviders>
  );
};

// Decided once per page load: the same-tab portal flow is recognised by its query string on the way out
// and by the pending entry in this tab's sessionStorage on the way back from the provider.
const App: React.FC = () =>
  isRedirectSignIn(window.location.search) ? <RedirectSignIn /> : <PusherSignIn />;

export default App;
